import { CSSProperties, useContext } from "react";

import styles from "./brandIcon.module.scss";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { isPartnerBranding } from "../../../utils/partnerBranding";

export type BrandIconProps = {
  src: string;
  className?: string;
  style?: CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  title?: string;
  alt?: string;
};

function BrandIcon({ src, className = "", style, onClick, title, alt = "" }: BrandIconProps): JSX.Element {
  const { branding }: iGlobalContext = useContext(StateContext);

  if (!isPartnerBranding(branding)) {
    return <img src={src} alt={alt} className={className || undefined} style={style} onClick={onClick} title={title} />;
  }

  return (
    <span
      className={`${styles.brandIcon} ${className}`}
      style={{ ...style, ["--zv-icon-src" as string]: `url("${src}")` } as CSSProperties}
      onClick={onClick}
      role={title || alt ? "img" : undefined}
      aria-label={title || alt || undefined}
      aria-hidden={title || alt ? undefined : true}
    />
  );
}

export default BrandIcon;
